/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
// import { useStaticQuery, graphql } from "gatsby";
import styled from "styled-components";
import { MainLayout } from "wmk-lib";

import Header from "./Header";
import Footer from "./Footer";
import get from "lodash/get";

const Wrap = styled.div`
  @media only screen {
    *:focus,
    *:active {
      outline: none;
    }
  }
  overflow: hidden;
`;

const Layout = ({ layoutProps, children }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `);
  // console.log('footLogoColor in MainLayout: ', footLogoColor);

  const logoSlug = get(layoutProps, `logoSlug`);
  const headLogoColor = get(layoutProps, `headLogoColor`);
  const headCtaStyle = get(layoutProps, 'headCtaStyle');
  const headCtaColor = get(layoutProps, `headCtaColor`);
  const showCta = get(layoutProps, `showCta`);
  const ctaRegion = get(layoutProps, 'ctaRegion');
  const footLogoColor = get(layoutProps, `footLogoColor`);
  const footBorderColor = get(layoutProps, `footBorderColor`);
  const footBorderThickness = get(layoutProps, `footBorderThickness`);
  const footMobileBg = get(layoutProps, `footMobileBg`);

  return (
    <Wrap>
      <MainLayout
        Header={() => (
          <Header
            logoSlug={logoSlug}
            headLogoColor={headLogoColor}
            headCtaStyle={headCtaStyle}
            headCtaColor={headCtaColor}
            showCta={showCta}
            ctaRegion={ctaRegion}
          />
        )}
        Footer={() => (
          <Footer
            footLogoColor={footLogoColor}
            footBorderColor={footBorderColor}
            footBorderThickness={footBorderThickness}
            footMobileBg={footMobileBg}
          />
        )}
      >
        {children}
      </MainLayout>
    </Wrap>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  layoutProps: PropTypes.object,
};

Layout.defaultProps = {
  layoutProps: {},
};

export default Layout;
